/*********************** Custom JS for Boost AI Search & Discovery  ************************/

if (window.boostSDAppConfig) { window.boostSDAppConfig.integration = Object.assign({ wishlists: 'plus' }, window.boostSDAppConfig.integration || {}); }

const isMobile = () => {
    let check = false;
    (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
    return check;
}


let windowWidth = 0; // Initialize the windowWidth variable to store the width.
const _checkIsMobile = () => {
   if (!windowWidth) {
      // We don't want to re-calculate the width every time because it causes a style recalculation every time.
      // So we store it
      windowWidth = window.innerWidth;

      // Calculate the width on resize
      window.addEventListener('resize', () => {
         windowWidth = window.innerWidth;
      });
   }
   return windowWidth <= 768;
};

// Check isCollectionPage
const isCollectionPage = () => {
    return window.location.pathname.includes('/collections');
};

function buildProgressBar(progressPercentage) {
    const progressBarContainer = document.createElement('div');
    progressBarContainer.className = 'boost-sd__progress-bar-container';
 
    const progressBar = document.createElement('div');
    progressBar.className = 'boost-sd__progress-bar';
    progressBar.style.width = progressPercentage + '%';
 
    progressBarContainer.appendChild(progressBar);
    return progressBarContainer;
 }
 
 window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat([
    (componentRegistry) => {
       componentRegistry.useComponentPlugin("PaginationLoadMore", {
          name: "Modify Component",
          enabled: true,
          apply: () => {
             return {
                afterRender(element) {
                   try {
                      const loadMoreButtonContainer = document.querySelector(".boost-sd__pagination-load-more-container-button");
                      let progressBarContainer = document.querySelector(".plp-progressbar");
                      const productCountElement = document.querySelector('.boost-sd__pagination-load-more-container-product-count .boost-sd__product-count');
                      if (productCountElement) {
                         const productCountText = productCountElement.textContent;
                         const regex = /Showing\s+(\d+)\s*-\s*(\d+)\s+of\s+(\d+)/i;
                         const matches = productCountText.match(regex);
                         if (matches && matches.length === 4) {
                            const startProduct = parseInt(matches[1], 10);
                            const endProduct = parseInt(matches[2], 10);
                            const totalProducts = parseInt(matches[3], 10);
                            const currentDisplayedProducts = endProduct;
                            const calcWidth = (currentDisplayedProducts / totalProducts) * 100.0;
                            if (!progressBarContainer) {
                               // Insert progress bar initially
                               productCountElement.insertAdjacentHTML('afterend', `<div class="plp-progressbar"><div class="plp-progressbar-inner" style="width:${calcWidth}%;"></div></div> `);
                            } else {
                               const progressBar = progressBarContainer.querySelector(".plp-progressbar-inner");
                               progressBar.style.setProperty('width', `${calcWidth}%`, 'important');
                            }
                         } else {
                            console.log("Error: Could not parse product count text.");
                         }
                      } else {
                         console.log("Error: Could not find product count element.");
                      }
                   } catch (error) {
                      console.log("Error in rendering/updating progress bar:", error);
                   } 
                },
             }; 
          },
       });
    },
 ]);
    
 window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat([
   (componentRegistry) => {
   componentRegistry.useComponentPlugin('ProductItem', {
     name: 'Modify Product Item Element',
     enabled: true,
     apply: () => ({
       afterRender(element){
         let elementHTML = element.getRootElm();
         let productData = element.getParams().props.product;
         let variantCount = productData.variants.length;
         let productItem = document.querySelector('.boost-sd__product-item[data-product-id="'+ productData.id +'"]');
         let swatchContainer = elementHTML.querySelector('.boost-sd__product-swatch');
         let compareAtPriceElement = elementHTML.querySelector('.boost-sd__format-currency--price-compare span');
         let comparePriceMin = parseFloat(productData.compare_at_price_min).toFixed(2);
         let comparePriceMax = parseFloat(productData.compare_at_price_max).toFixed(2);
         let comparePriceRange = comparePriceMin !== comparePriceMax ? "$" + comparePriceMin + ' - ' + "$" + comparePriceMax : "$" + comparePriceMin;
         if (compareAtPriceElement) {
           compareAtPriceElement.innerHTML = comparePriceRange;
         }

         if (!productItem) {
           return;
         }

         if (variantCount > 1) {
            let countString = "+ " + variantCount + " variants available";
            let variantCountElement = document.createElement('span');
            variantCountElement.className = 'boost-sd__variant-count';
            variantCountElement.textContent = countString;
            let existingVariantCountElement = elementHTML.querySelector('.boost-sd__variant-count');
            if (!existingVariantCountElement) {
               productItem.insertAdjacentHTML('beforeend', variantCountElement.outerHTML);
            }
         }

         const variants = productData.variants;
         const productImages = productData.images_info;


         variants.forEach(variant => {
            let variantTitle = variant.title;
            variantTitle = variantTitle.replace(/"/g, '\\"');
            let swatchName = "swatch_" + variantTitle;
             if (variantTitle != 'Default Title') {
               let swatchImage = "";
               productImages.forEach((image) => {
                  if (image?.alt?.includes(swatchName)) {
                     swatchImage = image.src;
                  }
               });
               
               let swatchElement = elementHTML.querySelector('[for*="' + variantTitle + '"]');
               if (swatchElement) {
                 swatchElement.style.backgroundImage = "url('" + swatchImage + "')";
               }
             }
         }); 
      }
   })
})
}
]);

window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat([
    (componentRegistry) => {
       componentRegistry.useComponentPlugin("ProductLabel", {
          name: "Modify Component",
          enabled: true,
          apply: () => {
               return {
                  props: (props) => {
                     let productBadge = window.productBadges[props.labelText];
                     props.backgroundColor = productBadge?.background_color;
                     props.color = productBadge?.text_color;
                     return props;
                  },
            }; 
         },
      });
   },
]);

window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat([
   (componentRegistry) => {
   componentRegistry.useComponentPlugin('ProductPrice', {
     name: 'Modify Product Price Element',
     enabled: true,
     apply: () => ({
      afterRender(element){
         let price = parseFloat(element.getParams().props.data.price_min).toFixed(2);
         let priceHigh = parseFloat(element.getParams().props.data.price_max).toFixed(2);
         let formattedPrice = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(price);
         let formattedPriceHigh = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(priceHigh);
         let elementHTML = element.getRootElm().querySelectorAll('.boost-sd__format-currency:not(.boost-sd__format-currency--price-compare) span');
         if (elementHTML && elementHTML.length > 0) {
            if(elementHTML.length == 2) {
               elementHTML[0].innerHTML = formattedPrice;
               elementHTML[1].innerHTML = formattedPriceHigh;
            } else if (elementHTML.length == 1) {
               elementHTML[0].innerHTML = formattedPrice;
            }
         }
         
      }
     })
   })
}
]);

const cardCTA = boostSDData && boostSDData.card_CTA;
const cardCTA2 = boostSDData && boostSDData.card_CTA_two;
const cardCTA3 = boostSDData && boostSDData.card_CTA_three;


const customBanner = {
    productListAfterRender: (componentRegistry) => {
       let preventReCallProductHandlesTheSame = [];
       componentRegistry.useComponentPlugin('ProductList', {
          name: 'Product List After Render',
          enabled: true,
          apply: () => ({
             afterRender(element) {
                if (!isCollectionPage()) return;
                try {
                   // Start customization ---------------------------------------
                   const helpersRef = element.getHelpers();
                   // Function get all handles displayed in product list
                   const productHandles = helpersRef.getProductHandles();
                   // Check duplicate not call. prevent call multi the same value
                   const isDuplicate = JSON.stringify(preventReCallProductHandlesTheSame) === JSON.stringify(productHandles);
                   preventReCallProductHandlesTheSame = productHandles;
 
                   if (productHandles?.length && !isDuplicate) {
                     var elements = document.getElementsByClassName("boost-sd__custom-card-CTA");
                     // Convert the HTMLCollection to an array for easier manipulation
                     var elementsArray = Array.from(elements);
                     // Remove each element
                     elementsArray.forEach(function(element) {
                         element.remove();
                     });
 

                      // Add general card
                      if (cardCTA && cardCTA.cta_title) {
                         insertCard(cardCTA);
                      }

                      if (cardCTA2 && cardCTA2.cta_title) {
                        insertCard(cardCTA2);
                     }

                     if (cardCTA3 && cardCTA3.cta_title) {
                        insertCard(cardCTA3);
                     }
                   }
                   // End customization ---------------------------------------
                } catch (err) {
                   console.warn(err);
                }
             }
          })
       })
    }
 }

window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat([customBanner.productListAfterRender]);

function compileCardTemplate(cardCTA, CTAMobile) {
    const {cta_title, cta_url, description, image, image_mobile, position, position_mobile, title} = cardCTA;
    const newElement = document.createElement(`${cta_url ? 'a' : 'div'}`);
    if (cta_url && cta_url != "") newElement.href = cta_url;
    let className = 'boost-sd__product-item boost-sd__product-item--no-border boost-sd__product-item-grid-view-layout boost-sd__custom-card-CTA';
        if (CTAMobile) {
            className += ' boost-sd__custom-card-CTA--mobile';
        } else {
            className += ' boost-sd__custom-card-CTA--desktop';
        };
    newElement.className = className;
    if (CTAMobile) {
        newElement.innerHTML = `
        <div class="overflow-hidden rounded relative h-full flex flex-col">
            <img class="object-cover w-full h-full" src="${image_mobile}" alt="${cta_title}">
            <div class="boost-sd-filter-product-item__promo--cta rounded p-5">
            <h4 class="mb-2 uppercase h3">${title}</h4>` +
            `     <span class="cta--link mt-4">${cta_title}</span>
            </div>
        </div>
        `;
    } else {
        newElement.innerHTML = `
        <div class="overflow-hidden rounded relative h-full flex flex-col justify-end">
            <img class="object-cover w-full h-full" src="${image}" alt="${cta_title}">
            <div class="boost-sd-filter-product-item__promo--cta rounded p-5">
            <h4 class="mb-2 mt-6 uppercase h3">${title}</h4>
            <div class="boost-sd-filter-product-item__cta-description">${description}</div>` +
            `     <span class="cta--link mt-4">${cta_title}</span>
            </div>
        </div>
        `;
    };
    let cardTemplate = newElement.outerHTML;
    return cardTemplate;
 }

function insertCard(cardCTA) {
    const cardHTML = compileCardTemplate(cardCTA, false);
    const mobileCardHTML = compileCardTemplate(cardCTA, true);
 
    const container = document.querySelector('.boost-sd__product-list');
 
    // Get the existing div at the specified index (if it exists)
    let cardIndexDesktop = cardCTA.position;
    let cardIndexMobile = cardCTA.position_mobile;
    const existingDiv = container.children[cardIndexDesktop - 2];
    const existingDivMobile = container.children[cardIndexMobile - 2];
    const lastDiv = container.lastChild;
 
    // Insert the new div before the existing div (if found), or append it at the end
    if (existingDiv) {
       existingDiv.insertAdjacentHTML('afterend', cardHTML);
    } else {
        lastDiv.insertAdjacentHTML('afterend', cardHTML);
    }

    if (existingDivMobile) {
        existingDivMobile.insertAdjacentHTML('afterend', mobileCardHTML);
    } else {
        lastDiv.insertAdjacentHTML('afterend', mobileCardHTML);
    }
 }
